const vendorVend = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'vendorVend',
        outputVars: {
          raasTransactionReference: '',
          vendorTransactionReference: '',
          vendorResponseCode: '',
          vendorResponseMessage: '',
          ctxTransactionReference: '',
          ctxSystemResponseCode: '',
          ctxTransactionResponseCode: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.raasTransactionReference',
    'integration.endNode.outputVars.vendorTransactionReference',
    'integration.endNode.outputVars.vendorResponseCode',
    'integration.endNode.outputVars.vendorResponseMessage',
    'integration.endNode.outputVars.ctxTransactionReference',
    'integration.endNode.outputVars.ctxSystemResponseCode',
    'integration.endNode.outputVars.ctxTransactionResponseCode',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.raasTransactionReference',
        'integration.endNode.outputVars.vendorTransactionReference',
        'integration.endNode.outputVars.vendorResponseCode',
        'integration.endNode.outputVars.vendorResponseMessage',
        'integration.endNode.outputVars.ctxTransactionReference',
        'integration.endNode.outputVars.ctxSystemResponseCode',
        'integration.endNode.outputVars.ctxTransactionResponseCode',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    raasTransactionReference: {
      type: 'text',
      label: 'RAAS transaction reference',
      validators: {
        required: true,
      },
    },
    vendorTransactionReference: {
      type: 'text',
      label: 'Vendor transaction reference',
      validators: {
        required: true,
      },
    },
    vendorResponseCode: {
      type: 'text',
      label: 'Vendor response code',
      validators: {
        required: true,
      },
    },
    vendorResponseMessage: {
      type: 'text',
      label: 'Vendor response message',
      validators: {
        required: true,
      },
    },
    ctxTransactionReference: {
      type: 'text',
      label: 'CTX transaction reference',
      validators: {
        required: true,
      },
    },
    ctxSystemResponseCode: {
      type: 'text',
      label: 'CTX system response code',
      validators: {
        required: true,
      },
    },
    ctxTransactionResponseCode: {
      type: 'text',
      label: 'CTX transaction response code',
      validators: {
        required: true,
      },
    },
  },
};
const vendorLookup = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'vendorLookup',
        outputVars: {
          raasTransactionReference: '',
          vendorTransactionReference: '',
          vendorResponseCode: '',
          vendorResponseMessage: '',
          ctxTransactionReference: '',
          ctxSystemResponseCode: '',
          ctxTransactionResponseCode: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.raasTransactionReference',
    'integration.endNode.outputVars.vendorTransactionReference',
    'integration.endNode.outputVars.vendorResponseCode',
    'integration.endNode.outputVars.vendorResponseMessage',
    'integration.endNode.outputVars.ctxTransactionReference',
    'integration.endNode.outputVars.ctxSystemResponseCode',
    'integration.endNode.outputVars.ctxTransactionResponseCode',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.raasTransactionReference',
        'integration.endNode.outputVars.vendorTransactionReference',
        'integration.endNode.outputVars.vendorResponseCode',
        'integration.endNode.outputVars.vendorResponseMessage',
        'integration.endNode.outputVars.ctxTransactionReference',
        'integration.endNode.outputVars.ctxSystemResponseCode',
        'integration.endNode.outputVars.ctxTransactionResponseCode',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    raasTransactionReference: {
      type: 'text',
      label: 'RAAS transaction reference',
      validators: {
        required: true,
      },
    },
    vendorTransactionReference: {
      type: 'text',
      label: 'Vendor transaction reference',
      validators: {
        required: true,
      },
    },
    vendorResponseCode: {
      type: 'text',
      label: 'Vendor response code',
      validators: {
        required: true,
      },
    },
    vendorResponseMessage: {
      type: 'text',
      label: 'Vendor response message',
      validators: {
        required: true,
      },
    },
    ctxTransactionReference: {
      type: 'text',
      label: 'CTX transaction reference',
      validators: {
        required: true,
      },
    },
    ctxSystemResponseCode: {
      type: 'text',
      label: 'CTX system response code',
      validators: {
        required: true,
      },
    },
    ctxTransactionResponseCode: {
      type: 'text',
      label: 'CTX transaction response code',
      validators: {
        required: true,
      },
    },
  },
};
const vendorPing = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'vendorPing',
        outputVars: {
          httpStatus: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.httpStatus',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.httpStatus',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    httpStatus: {
      type: 'text',
      label: 'HTTP status',
      validators: {
        required: true,
      },
    },
  },
};

export const vendorEndNodes: {} = {
  vendorVend: vendorVend,
  vendorLookup: vendorLookup,
  vendorPing: vendorPing,
};
